export const timerTypes = {
    loading: "LOADING_TIMER",
    delete: "DELETE_TIMER",
    loadedOne: "LOADED_TIMER",
    loadedMultiple: "LOADED_TIMERS",
    success: "SUCCESS_TIMER",
    restore: "RESTORE_TIMER",
    hardDelete: "HARDDELETE_TIMER",
};
